export const COMMON_REQ = 'cris/user/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/user/COMMON_REQ_FAIL';

export const LOAD_USERS_REQ = 'cris/user/LOAD_USERS_REQ';
export const LOAD_USERS_SUCCESS = 'cris/user/LOAD_USERS_SUCCESS';

export const LOAD_FILTERED_USERS_SUCCESS = 'cris/user/LOAD_FILTERED_USERS_SUCCESS';

const initialState = {
	isLoading: false,
	isSearched: false,
	error: null,
	roleList: [],
	regionList: [],
	businessUnitList: [],
	users: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_USERS_REQ:
			return {
				...state,
				isLoading: true,
				isSearched: false,
				users: []
			};

		case LOAD_USERS_SUCCESS:
			const rolesList = action.payload.data.roles.map(item => ({
				value: item.id,
				label: item.name
			}));

			const regionsList = action.payload.data.regions.map(item => ({
				value: item.id,
				label: `${item.code} - ${item.name}`
			}));

			const businessUnitsList = action.payload.data.business_units.map(item => ({
				value: item.id,
				label: `${item.code} - ${item.name}`
			}));

			return {
				...state,
				isLoading: false,
				roleList: rolesList,
				regionList: regionsList,
				businessUnitList: businessUnitsList
			};

		case LOAD_FILTERED_USERS_SUCCESS:
			const users = action.payload.data.users.map((item) => {
				const user = {
					id: item.id,
					name: item.name || '',
					email: item.email || '',
					mobile: item.mobile || '',
					contact_office: item.contact_office || '',
					contact_home: item.contact_home || '',
					time_clock_weekly_cap: item.time_clock_weekly_cap || '',
					status: item.status,
					roleNames: '',
					regionNames: '',
					businessUnitNames: '',
				};

				const roleNames = item.roles.map(role => role.name);
				const regionNames = [];
				const businessUnitNames = [];

				const workplacesLength = item.workplaces.length;
				for (let i = 0; i < workplacesLength; i += 1) {
					if (item.workplaces[i].role_type === 'Region User' && item.workplaces[i].region) {
						regionNames.push(item.workplaces[i].region.name);
					} else if (item.workplaces[i].role_type === 'Business Unit User' && item.workplaces[i].business_unit) {
						businessUnitNames.push(item.workplaces[i].business_unit.name);
					}
				}

				user.roleNames = roleNames.join(', ');
				user.regionNames = regionNames.join(', ');
				user.businessUnitNames = businessUnitNames.join(', ');

				return user;
			});

			return {
				...state,
				isLoading: false,
				isSearched: true,
				users: users
			};

		default:
			return state;
	}
}
